export default "__VITE_ASSET__CJPFjwGk__"